<template>
  <v-layout justify-center align-center fill-height pl-2 pt-4 pr-2 pb-2 row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 ms12>
            <v-card-title dense primary-title class="headline primary">
              <v-layout row align-center>
                <v-btn dark icon @click="$router.push('/settings/promotions/')">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <span class="title font-weight-light white--text">Add Promotion</span>
              </v-layout>
            </v-card-title>
          </v-flex>
          <v-card-text>
            <v-flex xs12 md12>
              <PromotionForm 
                ref="PromotionForm"
                :disabled="false"
                :promotion="promotion" 
                :errors="errors"
                @validityChange="updateFormValidity($event)"
              />
              <v-divider class="mx-1"></v-divider>
            </v-flex>
            <v-flex xs12 md12 pt-1>
              <v-layout align-center justify-end row>
                <v-btn color="success" @click="submit" class="text-none">
                  Submit
                </v-btn>
                </v-layout>
            </v-flex>
          </v-card-text>
        </v-layout>
      </v-card>
    </v-flex>
    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColour"
      :timeout="4000"
    >
      {{ snackbarMessage }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import PromotionForm from "@/components/settings/promotions/PromotionForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "create_promotion",
  components: {
    PromotionForm
  },
  data: function() {
    return {
      promotion: {
        name: "",
        description: "",
        user_description: "", //Description for the customer?
        start_date: "",
        end_date: "",
        code_lifespan_days: "",
        discount_type: "percentage", //fixed_amount or percentage
        discount_percentage: "", //Required if percentage
        discount_fixed: "", //Required if fixed - in pounds
        max_booking_cost_with_discount: "", //In pounds - for both discount types?
        cost_absorbed_by: "company", //company or driver
        allow_multiple_entries: false,
        codes: []
      },
      errors: {},
      promotionFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  methods: {
    submit: async function() {
      if (this.promotionFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/settings/promotions/create`;
        
        //Format promo to send
        //Copy not reference
        let promotionToSend = Object.assign({}, this.promotion);
        let codesToSend = [];
        promotionToSend.codes.forEach(function(promocode) {
          codesToSend.push(promocode.code)
        });
        promotionToSend.codes = codesToSend;

        let data = { promotion: promotionToSend };
        axios({
          url: url,
          method: "post",
          data: encodeURIComponent(JSON.stringify(data)),
          headers: {
            'Content-Type': 'text/plain'
          }
        }).then(function(response) {
          console.log(response.data.errors)
          if(response.data.errors) {
            self.errors = response.data.errors;
            self.snackbarMessage = "Error adding promotion, please check the form"
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else if(response.data.error != "no_error") {
            self.snackbarMessage = "Error adding promotion: " + response.data.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
            console.log(response.data.error)
          } else {
            const promotionID = response.data.promotion.id;
            self.$router.push('../promotions/');
          }
        }).catch(function(error) {
          console.log(error);
          self.snackbarMessage = "Network error: " + error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.PromotionForm.validateForm();
      }
    },
    updateFormValidity: function(value) {
      this.promotionFormValid = value;
    }
  }
}
</script>